export default function getPassword() {
  return Math.random().toString(36).slice(-8);
}



// WEBPACK FOOTER //
// ./src/utils/getPassword.js